import {DMap} from "../../../../../Server/DB/maps/@Map.js";
import {MapState} from "../../../../../Store/main/maps/@MapState.js";
import {Vec2, Vec3} from "../../../../../Utils/ThreeJS/VectorStructs.js";
import {ReactNode} from "react";
import {MapControls} from "../../MapSurface/MapControls.js";

// declare this here, so we don't get an import loop (of: store -> ToolX -> Tool -> store)
export enum MapTool {
	none = "none",
	pan = "pan",
	select = "select",
	measure = "measure",
	cursor = "cursor",
	addObject = "addObject",
	move = "move",
	resize = "resize",
	meshModify = "meshModify",
	pathModify = "pathModify",
}

export type MousePosData = {mousePos: Vec2, mousePos_world: Vec3};

/* eslint-disable @typescript-eslint/no-namespace */
export namespace ToolData {
	export type RenderInToolbox =      {map: DMap, mapState: MapState};
	export type RenderInScene =        {map: DMap, mapState: MapState};
	export type RenderInSceneOverlay = {map: DMap, mapState: MapState};

	export type Tool_OnActivate =   {map: DMap, mapState: MapState};
	export type Tool_OnDeactivate = {map: DMap, mapState: MapState};

	// pointer
	export type Scene_OnPointerDown =    {event: PointerEvent, controls: MapControls} & MousePosData;
	export type Scene_OnPointerMove =    {event: PointerEvent, controls: MapControls} & MousePosData;
	export type Scene_OnPointerUp =      {event: PointerEvent, controls: MapControls} & MousePosData;
	export type Scene_OnPointerClick =   {event: PointerEvent, controls: MapControls} & MousePosData;
	export type Document_OnPointerMove = {event: PointerEvent, controls: MapControls} & MousePosData;
	export type Document_OnPointerUp =   {event: PointerEvent, controls: MapControls} & MousePosData;

	// mouse
	export type Scene_OnMouseWheel = {event: MouseEvent, controls: MapControls} & MousePosData;

	// keys
	export type Scene_OnKeyDown =    {event: KeyboardEvent, controls: MapControls};
	export type Scene_OnKeyUp =      {event: KeyboardEvent, controls: MapControls};
	export type Document_OnKeyDown = {event: KeyboardEvent, controls: MapControls};
	export type Document_OnKeyUp =   {event: KeyboardEvent, controls: MapControls};

	// touch
	export type Scene_OnTouchStart =   {event: TouchEvent, controls: MapControls};
	export type Document_OnTouchMove = {event: TouchEvent, controls: MapControls};
	export type Document_OnTouchEnd =  {event: TouchEvent, controls: MapControls};
}
/* eslint-enable @typescript-eslint/no-namespace */

export type ToolInterceptSubresult = {
	absorb?: boolean;
};

export abstract class Tool {
	abstract toolType: MapTool;
	/*get ToolState() {
		return store.main.maps.toolStates[this.toolType];
	}*/

	/*Override<T>(func: T, replacement: T): T {
		return replacement;
	}*/

	RenderInToolbox?(props: {data: ToolData.RenderInToolbox}): ReactNode;
	RenderInScene?(props: {data: ToolData.RenderInScene}): ReactNode;
	RenderInSceneOverlay?(props: {data: ToolData.RenderInSceneOverlay}): ReactNode;
	/*RenderForObject?(obj: MapObject, extraInfo: ToolRender_ExtraInfo): ReactNode;
	RenderForObject_Overlay?(obj: MapObject, extraInfo: ToolRender_ExtraInfo): ReactNode;*/

	Tool_OnActivate(data: ToolData.Tool_OnActivate): void {}
	Tool_OnDeactivate(data: ToolData.Tool_OnDeactivate): void {}

	// pointer
	Scene_OnPointerDown(data: ToolData.Scene_OnPointerDown): ToolInterceptSubresult | void {}
	Scene_OnPointerMove(data: ToolData.Scene_OnPointerMove): ToolInterceptSubresult | void {}
	Scene_OnPointerUp(data: ToolData.Scene_OnPointerUp): ToolInterceptSubresult | void {}
	Scene_OnPointerClick(data: ToolData.Scene_OnPointerClick): ToolInterceptSubresult | void {}
	Document_OnPointerMove(data: ToolData.Document_OnPointerMove): ToolInterceptSubresult | void {}
	Document_OnPointerUp(data: ToolData.Document_OnPointerUp): ToolInterceptSubresult | void {}

	// mouse
	Scene_OnMouseWheel(data: ToolData.Scene_OnMouseWheel): ToolInterceptSubresult | void {}

	// touch
	Scene_OnTouchStart(data: ToolData.Scene_OnTouchStart): ToolInterceptSubresult | void {}
	Document_OnTouchMove(data: ToolData.Document_OnTouchMove): ToolInterceptSubresult | void {}
	/** Note: This also triggers for touchcancel events. */
	Document_OnTouchEnd(data: ToolData.Document_OnTouchEnd): ToolInterceptSubresult | void {}

	// keys
	Scene_OnKeyDown(data: ToolData.Scene_OnKeyDown): ToolInterceptSubresult | void {}
	Scene_OnKeyUp(data: ToolData.Scene_OnKeyUp): ToolInterceptSubresult | void {}
	Document_OnKeyDown(data: ToolData.Document_OnKeyDown): ToolInterceptSubresult | void {}
	Document_OnKeyUp(data: ToolData.Document_OnKeyUp): ToolInterceptSubresult | void {}
}